/**
 * NeoPixelCard — 全息像素卡片
 * 科技毛玻璃 + 细线霓虹描边 + 四角机甲准星 [+]，可选 45° 倒角。
 * 工单：Neo-Pixel 视觉体系 · 通用容器
 */
import type { CSSProperties, ReactNode } from "react";

export interface NeoPixelCardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  /** 四角准星装饰，默认开启 */
  corners?: boolean;
  /** 45° 倒角切角（机甲风），默认关闭 */
  bevel?: boolean;
  /** 语义强调色 */
  accent?: "cyan" | "violet" | "pink" | "mint";
  hoverable?: boolean;
}

const ACCENT_BORDER: Record<NonNullable<NeoPixelCardProps["accent"]>, string> =
  {
    cyan: "rgba(0,240,255,0.25)",
    violet: "rgba(139,92,246,0.32)",
    pink: "rgba(255,122,217,0.3)",
    mint: "rgba(56,189,248,0.3)", /* 负向清单：禁荧光绿 → 冰青 */
  };

export function NeoPixelCard({
  children,
  className = "",
  style,
  corners = true,
  bevel = false,
  accent = "cyan",
  hoverable = true,
}: NeoPixelCardProps) {
  return (
    <div
      className={`neo-card ${hoverable ? "" : "neo-card-static"} ${
        bevel ? "neo-card-bevel" : ""
      } ${className}`}
      style={{ borderColor: ACCENT_BORDER[accent], ...style }}
    >
      {corners && (
        <>
          <span className="neo-card-corner neo-card-corner-tl" aria-hidden />
          <span className="neo-card-corner neo-card-corner-tr" aria-hidden />
          <span className="neo-card-corner neo-card-corner-bl" aria-hidden />
          <span className="neo-card-corner neo-card-corner-br" aria-hidden />
        </>
      )}
      {children}
    </div>
  );
}

export default NeoPixelCard;
